module.exports = __webpack_public_path__ + "img/mohamadElGhali2.d22c134d.png";